import type {SystemMessage} from '@myparcel-frontend/types';
import {useStorage} from '@vueuse/core';
import {defineStore} from 'pinia';
import {ref} from 'vue';

// 90 seconds or 1.5 minutes
const EXPIRATION_TIME = 3000 * 30;

export interface DismissedMessage {
  id: number;
  modified: Date;
}

export type DismissedMessages = Record<string, Date>;

export const useSystemMessagesStore = defineStore('systemMessages', () => {
  const systemMessages = useStorage('systemMessages', [] as SystemMessage[]);
  const expirationDate = useStorage('systemMessagesExpirationDate', 0);
  const dismissedMessages = useStorage('turnedOffNotifications', {} as DismissedMessages);
  const additionalFilters = ref<string>();

  const isExpired = () => {
    return expirationDate.value < Date.now();
  };

  const isDismissed = (message: SystemMessage) => {
    const {id, modified} = message;
    const dismissedMessage = dismissedMessages.value[id.toString()];
    return dismissedMessage && dismissedMessage === modified;
  };

  const setSystemMessages = (messages: SystemMessage[]) => {
    systemMessages.value = messages;
    expirationDate.value = Date.now() + EXPIRATION_TIME;
  };

  const addDismissedMessage = (message: SystemMessage) => {
    const {id, modified} = message;
    dismissedMessages.value[id.toString()] = modified;
  };

  return {
    systemMessages,
    expirationDate,
    dismissedMessages,
    additionalFilters,
    isExpired,
    isDismissed,
    setSystemMessages,
    addDismissedMessage,
  };
});
